import { CENotificationAttributesBase } from './ce-notification-attributes-base'


export class CENotificationAttributes extends CENotificationAttributesBase {

}